<template>
  <div>
    <page-header :title="$t('bill.bill_config_create')" />
    <page-body needMarginBottom>
      <a-row :gutter="10">
          <a-col :md="{ span: 24 }" :lg="{ span: 24 }" :xl="{ span: 22 }" :xxl="{ span: 20 }">
            <a-form-model
              ref="configForm"
              class="mt-3"
              :model="form"
              :rules="rules"
              v-bind="formItemLayout">
              <a-form-model-item :label="$t('common.name')" prop="name">
                <a-input v-model="form.name" :placeholder="$t('validator.resourceName')" />
                <name-repeated
                  v-slot:extra
                  res="shield_bills"
                  version="v1"
                  :name="form.name" />
              </a-form-model-item>
              <a-form-model-item :label="$t('bill.cost_conversion_env_brand')">
                <a-row :gutter="24">
                  <a-col :span="8">
                    <base-select
                      v-model="form.cloud_env"
                      filterable
                      id-key="item_id"
                      name-key="item_name"
                      minWidth="160px"
                      :options="uniqueArr(options.cloud_envs)"
                      @change="v => change('cloud_env', v)"
                      :select-props="{ placeholder: $t('bill.text_49') }" />
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item prop="platform_brand">
                      <base-select
                        v-model="form.platform_brand"
                        filterable
                        id-key="item_id"
                        name-key="item_name"
                        minWidth="160px"
                        :options="uniqueArr(options.platform_brands)"
                        @change="v => change('platform_brand', v)"
                        :select-props="{ required: true, placeholder: $t('bill.text_49') }" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <base-select
                      :selectProps="{labelInValue: true}"
                      v-model="form.account_id"
                      filterable
                      id-key="item_id"
                      name-key="item_name"
                      minWidth="160px"
                      @change="v => change('account_id', v)"
                      :options="options.accounts"
                      :select-props="{ placeholder: $t('bill.text_49') }" />
                  </a-col>
                </a-row>
              </a-form-model-item>
              <a-form-model-item :label="$t('bill.shield_res_type')" :rules="rules.product" prop="product">
                <a-row :gutter="24">
                  <a-col :span="16">
                    <base-select
                      v-model="form.product"
                      filterable
                      minWidth="160px"
                      :options="allProductOpts"
                      :select-props="{ placeholder: `${$t('common.select')}${$t('bill.shield_res_type')}`, mode: 'multiple' }" />
                  </a-col>
                  <a-col :span="8">
                    <a-button type="link" @click="handleImportClick">{{$t('bill.import_resource_type_from_file')}}</a-button>
                  </a-col>
                </a-row>
              </a-form-model-item>
            </a-form-model>
          </a-col>
        </a-row>
    </page-body>
    <page-footer>
      <div slot="right">
        <a-button class="ml-3 mr-3" type="primary" :loading="loading" @click="doOk()">{{ $t('dialog.ok') }}</a-button>
        <a-button @click="cancel">{{ $t('dialog.cancel') }}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import _ from 'lodash'
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import { ACCOUNTS } from '@Bill/constants'
import WindowsMixin from '@/mixins/windows'
import { BRAND_MAP } from '@/constants'
import { uuid } from '@/utils/utils'
import NameRepeated from '@/sections/NameRepeated/index'

const cloudParamMap = {
  onpremise: 'onpremise',
  private: 'false',
  public: 'true',
}

export default {
  name: 'BillconfigCreate',
  components: {
    NameRepeated,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      loading: false,
      options: {
        cloud_envs: [
          {
            item_id: 'public',
            item_name: this.$t('cloud_env.public'),
          },
        ],
        platform_brands: [],
        accounts: ACCOUNTS,
      },
      form: {
        cloud_env: 'public',
        platform_brand: '',
        account_id: { key: 'all' },
        product: [],
      },
      productOpts: [],
      fileProductOpts: [],
      rules: {
        name: [
          { required: true, message: `${this.$t('common.placeholder')}${this.$t('common.name')}` },
          { validator: this.$validate('resourceName') },
        ],
        product: [
          { required: true, message: `${this.$t('common.select')}${this.$t('bill.shield_res_type')}` },
          {
            validator: () => {
              return this.form.product.length > 0
            },
          },
        ],
        platform_brand: [
          { required: true, message: this.$t('common.tips.select', [this.$t('cloudevent.title.brand')]) },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      selectedPlatformBrand: '',
    }
  },
  computed: {
    ...mapGetters(['scope', 'isAdminMode']),
    ...mapState('common', {
      currency: state => state.bill.currency,
      currencyOpts: state => state.bill.currencyOpts,
      exchangeRateAvailable: state => state.bill.exchangeRateAvailable,
    }),
    productParams () {
      const ret = {
        scope: this.$store.getters.scope,
        cloud_env: 'public',
        query_type: 'product_detail',
        filter: [],
      }
      if (this.form.platform_brand) {
        ret.filter.push(`brand.equals(${this.form.platform_brand})`)
      }
      if (this.form.account_id && this.form.account_id.key !== 'all') {
        ret.filter.push(`account_id.equals(${this.form.account_id.key})`)
      }
      return ret
    },
    allProductOpts () {
      const list = [...this.fileProductOpts]
      this.productOpts.map(item => {
        const target = list.filter(l => l.id === item.id)
        if (!target.length) list.push(item)
      })
      return list
    },
  },
  created () {
    this.conditionM = new this.$Manager('bill_conditions', 'v1')
    this._conditionList('platform_brand', [], { is_public_cloud: true })
    this.getProductList()
  },
  methods: {
    async getProductList () {
      try {
        this.productLoading = true
        const res = await this.conditionM.list({
          params: this.productParams,
        })
        const list = ((res.data && res.data.data) || []).filter(item => {
          return item.item_id && item.item_name
        })
        this.productOpts = list.map(item => {
          return {
            id: item.item_id,
            name: `${item.item_name}（${item.item_id}）`,
          }
        })
        this.form.product = this.form.product.filter(item => {
          const targets = list.filter(l => l.id === item)
          return targets.length > 0
        })
        this.productLoading = false
      } catch (err) {
        this.productLoading = false
        throw err
      }
    },
    handleImportClick () {
      this.createDialog('BillShieldImportResourceTypeDialog', {
        ok: (data) => {
          const resourceTypeList = []
          const idList = []
          data.map(item => {
            const row = { product_code: '', regions: [], rate: null, duration: '' }
            // 产品明细
            row.id = item['产品明细Code']
            row.name = `${item['产品明细']}（${row.id}）`
            resourceTypeList.push(row)
            idList.push(row.id)
          })
          this.fileProductOpts = resourceTypeList
          if (resourceTypeList.length) {
            this.form.product = idList
          }
        },
      })
    },
    cancel () {
      this.$router.push('/bill-config')
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs.configForm.validate((valid, err) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(err)
          }
        })
      })
    },
    doCreate (data) {
      return new this.$Manager('shield_bills', 'v1').create({ data: data })
    },
    async doOk () {
      try {
        const checked = await this.validateForm()
        if (!checked) return
        this.loading = true
        const {
          platform_brand,
          cloud_env,
          account_id,
          name,
          product,
        } = this.form
        const is_public_cloud = cloudParamMap[cloud_env]
        const params = {
          generate_name: name,
          is_public_cloud,
          cloud_env: cloud_env === 'all' ? '' : cloud_env,
          brand: platform_brand === 'all' ? '' : platform_brand,
          account_id: account_id?.key === 'all' ? '' : account_id?.key,
          product: product.map(id => {
            const list = this.allProductOpts.filter(item => item.id === id)
            return {
              product_code: list[0].id,
              product_name: list[0].name,
            }
          }),
        }
        await this.doCreate(params)
        this.$router.push('/bill-config')
        this.loading = false
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    _conditionList (queryType, cons = [], reqQuery = {}) {
      const adminParams = { admin: this.isAdminMode, scope: this.scope, $t: uuid() }
      const query = Object.assign({ query_type: queryType, cloudaccount_exist: true }, reqQuery, adminParams)
      // 先清空
      this.options[`${queryType}s`] = [...cons]
      this.conditionM.list({ params: query }).then(({ data: { data } }) => {
        if (queryType === 'platform_brand') {
          data = data.map(v => {
            return { ...v, item_name: (_.get(BRAND_MAP, `[${v.item_name}].label`) || v.item_name) }
          })
          const platform_brand = this.form.platform_brand
          if (!platform_brand && data[0]) {
            this.form.platform_brand = data[0].item_id
            this.change('platform_brand', data[0].item_id)
          }
        }
        this.options[`${queryType}s`] = [...cons, ...data]
      })
    },
    uniqueArr (arr, byId = 'item_id') {
      const obj = {}
      arr.forEach(val => {
        obj[val[byId]] = val
      })
      return Object.values(obj)
    },
    change (type, value) {
      const id = R.type(value) === 'Object' ? value.key : value
      if (type === 'cloud_env') {
        this.$nextTick(() => {
          this.form.platform_brand = ''
          this.form.account_id = { key: 'all' }
        })
        const query = { parent_id: id }
        const platform_query = {}
        if (id !== 'all') {
          platform_query.is_public_cloud = cloudParamMap[value]
        }
        this._conditionList('platform_brand', [], platform_query)
        this._conditionList('account', ACCOUNTS, query)
        this.selectedPlatformBrand = ''
      }
      if (type === 'platform_brand') {
        this.$nextTick(() => {
          this.form.account_id = { key: 'all' }
          this.form.product = []
        })
        const query = { brand: id }
        this._conditionList('account', ACCOUNTS, query)
        this.selectedPlatformBrand = id
        this.getProductList()
      }
      if (type === 'account_id') {
        this.getProductList()
      }
    },
  },
}
</script>
